<template>
    <div v-if="!hide" class="form-network form-network-google" >

        <details open>
            <summary>{{ $t('dash.post-creator.form.link-preview') }} <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail form-link">
                <div class="list-thubmmail">
                  
                    <div class="thubmmail" v-for="(url) in draftInstance.form.urlsTextContentHistory" @click="()=>selectUrl(url.value)" :key="url">
                        <Checkbox :id="url.value" :prefixId="'thubmmail-'" 
                            :isChecked="(draftInstance.form.networks.google.snippet.link == url.value)" 
                            :isDisable="(draftInstance.form.networks.google.snippet.link == url.value)"
                            :add="() => selectUrl(url.value)" 
                            :remove="()=>{}">
                        </Checkbox>
                        <SnippetNetwork 
                            :link="url"
                            :imageUrlDefault="!inputModel.switchCustomSnippet || inputModel.titleSnippet || inputModel.descriptionSnippet ? undefined : inputModel.urlImageSnippet" 
                            :titleDefault="inputModel.switchCustomSnippet ? inputModel.titleSnippet : undefined" 
                            :descriptionDefault="inputModel.switchCustomSnippet ? inputModel.descriptionSnippet : undefined">
                        </SnippetNetwork>
                    </div>
                </div>
              
            </div>
        </details>
   </div>
</template>

<script>
   import { EventBus } from '@/event-bus';
   import store from '@/store/index.js';
   import ComponentSwitch from '@/components/dash/utils/switch.vue'
   import SelectComponent from '@/components/dash/utils/select.vue'
   import SnippetNetwork from './../SnippetNetwork.vue'
   import minxinBot from '@/components/mixins/Bots.vue'
   import minxinPost from '@/components/mixins/Posts.vue'
   import Checkbox from '@/components/dash/utils/checkbox.vue'
   import { VueDraft } from '@mashupweb/draft-lib';
   export default {

       components: {
           ComponentSwitch,
           SelectComponent,
           SnippetNetwork,
           Checkbox
       },
       mixins: [minxinBot,minxinPost],

       props: {
           hide : {
               type: Boolean,
               default: false
           },

           draftInstance: VueDraft
       },

       data() {
           return {
                inputModel:{
                    switchCustomSnippet: false,
                    urlImageSnippet: "",
                    titleSnippet: "",
                    descriptionSnippet: "",
                },

                lastModeSelected : undefined
           }
       },

       
    
       methods: {
            addMode(mode) {
                this.lastModeSelected = mode
                EventBus.$emit("postCreatorAddMode", mode);
            },

            selectUrl(url) {
                if (this.draftInstance.form.networks.google.snippet.link == url) {
                    this.draftInstance.form.networks.google.snippet.unselect()
                }else{
                        this.draftInstance.form.networks.google.snippet.select(url)
                }
            },

       },

       computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },
       },




       beforeDestroy () {
         
       }
       
   }
</script>